import { jsx as _jsx } from "react/jsx-runtime";
import * as S from './Toolbar.css';
const Toolbar = (props) => {
    return _jsx(S.Toolbar, { children: props.children });
};
export default Toolbar;
